// @flow
import React, { Component } from 'react';
import QuoteCardList from 'components/common/QuoteCardList/QuoteCardList';
import type { State } from 'store';
import { QuotingActions } from 'store/actionCreators';
import { type UserData } from 'store/modules/user';
import type { QuoteItem } from 'store/modules/quoting';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type OwnProps = {
  sort: string,
  category: string,
};

type Props = OwnProps & {
  quotes: ?(QuoteItem[]),
  prefetched: ?(QuoteItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
  user: ?UserData,
};

class QuotingQuoteCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { quotes, prefetching, loading, category, sort } = this.props;
    if (!quotes || quotes.length === 0 || prefetching || loading) return;
    const lastId = quotes[quotes.length - 1].id;
    if (this.props.prefetched) {
      QuotingActions.revealPrefetched('recent');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await QuotingActions.prefetchRecentQuotes(lastId, category, sort);
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { quotes, shouldCancel, category, sort } = this.props;
    try {
      if (quotes && quotes.length > 0) {
        // do not fetch quote data when already exists
        return;
      }
      if (!shouldCancel) {
        await QuotingActions.getRecentQuotes('', category, sort);
      }
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { category, sort } = this.props;
    await QuotingActions.getRecentQuotes('', category, sort);
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentWillUnmount() {
    this.unlistenScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
  }

  render() {
    return (
      <QuoteCardList
        quotes={this.props.quotes}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
        user={this.props.user}
      />
    );
  }
}

const mapStateToProps = ({ quoting, pender, base, common, user }: State) => ({
  quotes: quoting.recent.quotes,
  prefetched: quoting.recent.prefetched,
  prefetching: pender.pending['quoting/PREFETCH'],
  loading: pender.pending['quoting/GET_RECENT_POSTS'],
  width: base.windowWidth,
  hasEnded: quoting.recent.end,
  shouldCancel: common.ssr && !common.router.altered,
  user: user.user,
});

export default connect(mapStateToProps, () => ({}))(QuotingQuoteCards);



// WEBPACK FOOTER //
// ./src/containers/list/QuotingQuoteCards.js